import { createMutationHelper } from '@utils/swr'
import { type PaymentTransactionResponse } from '../types/apiResponse'
import { type FortuneApis } from '../types/apis'

const { useMutation } = createMutationHelper<FortuneApis['get']['paymentTransaction'], PaymentTransactionResponse, { 'id': string, 'access-token'?: string }>({
  client: 'fortuneMember',
  key: '/payment_transactions',
  fetcher: (_url, { arg, client }) => {
    if (!arg.id) {
      return Promise.reject(new Error('Transaction ID is required'))
    }
    const dynamicUrl = `/payment_transactions/${arg.id}`
    const headers = {
      ...(arg['access-token'] ? { 'access-token': arg['access-token'] } : {}),
    }

    return client.get(dynamicUrl, {
      headers,
    })
  },
})

export const useApiGetPaymentTransactionMutation = useMutation
